module.exports = "https://www.gc-qa.gnp.com.mx/36712ad1398cb74dc03e8a8934f1d2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/edit_orange_24px.png
// module id = 8101
// module chunks = 0